// extracted by mini-css-extract-plugin
module.exports = {"share":"Share-module--share--3hhFg","share__title":"Share-module--share__title--2Zlwv","share__button":"Share-module--share__button--1cFG-"};